import { ChallengeType, DepositStatus, WithdrawalStatus, LeaderboardWinnerType, DiscountCodeStatus, HcpType, GameType } from '../utils/const';

export function translateChallengeType(type) {
    switch (type) {
        case ChallengeType.FREE:
            return "Free";
        case ChallengeType.PAYED:
            return "Buy in";
        case ChallengeType.SPONSORED:
            return "Sponsored";
        case ChallengeType.QUALIFIER:
            return "Fridayplay Challenge Qualifier";
        case ChallengeType.FINAL:
            return "Fridayplay Challenge Final";
        default:
            return "Unknown";
    }
}

export function translateGameType(type) {
    switch (type) {
        case GameType.STROKE_PLAY_NET:
            return "Net Stroke play";
        case GameType.STABLEFORD_NET:
            return "Net Stableford";
        case GameType.STABLEFORD:
            return "Stableford";
        case GameType.STROKE_PLAY:
            return "Stroke play";
        default:
            return "Unknown";
    }
}

export function translateHcpType(hcpType) {
    switch (hcpType) {
        case HcpType.SINGLE:
            return "HCP Single";
        case HcpType.HCP_1_18:
            return "HCP up to 18";
        case HcpType.HCP_19_36:
            return "HCP up to 54";
        case HcpType.ANY:
            return "Any";
        case HcpType.PRO:
            return "Pro";
        default:
            return "Unknown";
    }
}

export function translateLeaderboardWinnerType(type) {
    switch (type) {
        case LeaderboardWinnerType.DAILY_SCORE:
            return "Daily";
        case LeaderboardWinnerType.WEEKLY_SCORE:
            return "Weekly";
        case LeaderboardWinnerType.MONTHLY_SCORE:
            return "Monthly";
        default:
            return "Unknown";
    }
}

export function translateDepositStatus(status) {
    switch (status) {
        case DepositStatus.CREATED:
            return "Created";
        case DepositStatus.REQUESTED:
            return "Not complete";
        case DepositStatus.COMPLETE:
            return "Complete";
        case DepositStatus.CANCELLED:
            return "Cancelled";
        case DepositStatus.PENDING:
            return "Pending";
        default:
            return "Unknown";
    }
}

export function translateWithdrawalStatus(status) {
    switch (status) {
        case WithdrawalStatus.DENIED:
            return "Denied";
        case WithdrawalStatus.REQUESTED:
            return "Requested";
        case WithdrawalStatus.COMPLETE:
            return "Complete";
        case WithdrawalStatus.FAILED:
            return "Failed";
        default:
            return "Unknown";
    }
}

export function translateDiscountCodeStatus(status) {
    switch (status) {
        case DiscountCodeStatus.CREATED:
            return "Created";
        case DiscountCodeStatus.DISTRIBUTED:
            return "Distributed";
        case DiscountCodeStatus.USED:
            return "Used";
        case DiscountCodeStatus.REVOKED:
            return "Revoked";
        default:
            return "Unknown";
    }
}

export function translateDepositSuccededResult(amount, totalAmount) {
    return `You have deposited $${amount} to your account. Your new total is $${totalAmount}`;
}

export function translateWithdrawRequestSuccededResult(amount, totalAmount) {
    return `You have requested a withdrawal of $${amount} from your account. Your new total is $${totalAmount}. We will complete your request shortly.`;
}


export const showScore = ({ strokes, points }) => {

    if (typeof strokes !== 'undefined' && strokes !== null) {
        return ' ' + strokes + ' strokes';
    }
    else if (typeof points !== 'undefined' && points !== null) {
        return ' ' + points + ' points';
    }
    else {
        return '';
    }
}